export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-4.8857c069.png";